import {RequestScope} from '~/api'
import {createBffHooks} from '~/bff'
import {defineClientContext} from '~/bff/operational-context'
import {useFlags} from '~/flags'

import type {GetUserAddingRequestsType} from '../../../bff/moons/generated/oberon-v1'
import type {InviteUsersRouter} from '../backend/index.bff'

const accessRequestsBffHooks = createBffHooks<InviteUsersRouter>().accessRequests

const useEnabledRequestType = (): GetUserAddingRequestsType | undefined => {
    const {isMobileEmployeeSignupActive} = useFlags()
    // 'undefined' means all types.
    return isMobileEmployeeSignupActive ? undefined : 'ON_BEHALF_OF_EMPLOYEE'
}

export const useAccessRequestCount = ({enabled}: {enabled: boolean}) => {
    const type = useEnabledRequestType()
    return accessRequestsBffHooks.getAccessRequestCount.useQuery(
        {
            type,
        },
        {
            enabled,
        },
    )
}
export const useAccessRequests = ({enabled}: {enabled: boolean}) => {
    const type = useEnabledRequestType()
    return accessRequestsBffHooks.getAccessRequestsV2.useQuery(
        {
            type,
        },
        {
            enabled,
        },
    )
}
export const useDeclineUserAccessRequests =
    accessRequestsBffHooks.declineUserAccessRequests.useMutation
export const useApproveAccessRequestsAndSendInvites =
    accessRequestsBffHooks.approveAccessRequestsAndSendInvites.useMutation

export const useUpgradePlanAndApproveAccessRequests = () =>
    accessRequestsBffHooks.upgradeSubscriptionAndSendInvites.useMutation({
        trpc: {
            context: defineClientContext({
                auth: {
                    type: 'elevated',
                    scope: RequestScope.CARD,
                },
            }),
        },
    })

export default accessRequestsBffHooks
